var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLanguageConvterWhiteIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlns: "http://www.w3.org/2000/svg",
    width: 36,
    height: 32,
    viewBox: "0 0 36 32",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.9953 20.9236L14.9306 16.9069L14.9786 16.8589C17.7631 13.7544 19.7474 10.1858 20.9156 6.4091H25.6045V3.2006H14.4025V0H11.2019V3.2006H0V6.3851H17.8751C16.7949 9.4736 15.1065 12.4021 12.8022 14.9626C11.3139 13.3063 10.0817 11.506 9.1055 9.6017H5.905C7.0732 12.2101 8.6735 14.6745 10.6738 16.8989L2.5364 24.9403L4.8008 27.2047L12.8022 19.2033L17.7791 24.1802L18.9953 20.9236Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M28.0073 12.8047H24.8067L17.6055 32.008H20.806L22.6064 27.2072H30.2076L32.0079 32.008H35.2085L28.0073 12.8047ZM23.8066 24.0066L26.407 17.0694L29.0075 24.0066H23.8066Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLanguageConvterWhiteIcon);
export default __webpack_public_path__ + "static/media/language-convter-white-icon.ddae52d2d6a006c6facc74f30231e0a3.svg";
export { ForwardRef as ReactComponent };